import _get from 'lodash/get';

import { BRAND_IDENTITIES } from '../../../components/modules/foundation/hooks/use-branding/useBranding.constants';

export function shouldDisplayHelpCenter(state) {
  const branding = _get(state, 'business.core.value.brand_identity');

  return branding === BRAND_IDENTITIES.FISHERMAN;
}
